import ClockContainer from "./ClockContainer";


function App() {
  return (
    <ClockContainer />
  );
}

export default App;
